/**
 * Field label translations carry no trailing colon so the same keys can be reused as table column headers.
 * Form and search field labels add it here instead. Any colon already present (e.g. on a label coming from
 * the BE) is normalised so it is never doubled, and an empty label stays empty.
 */
export const withLabelColon = (label: string): string => {
    const trimmed = label.trimEnd();
    const text = trimmed.endsWith(":") ? trimmed.slice(0, -1).trimEnd() : trimmed;
    return text ? `${text}:` : label;
};
